export default __webpack_public_path__ + "static/media/netis.f329ebff.png";